/**
 * /*
 *
 * @format
 * @Description:
 * @Author: changfu
 * @Date: 2020-06-10 20:34:19
 * @LastEditTime: 2020-06-12 09:54:44
 * @LastEditors:
 */

/** @format */
import logLogin from './logLogin';
import applicationResources from './applicationResources';
import organization from './organization'
import userList from './userList'
import common from './common'
import roleList from './roleList'
import dataAuth from './dataAuth'

const tcList = { ...applicationResources, ...logLogin, ...organization, ...userList, ...common, ...roleList, ...dataAuth };
const tc = {
  appName: {
    loc: '商業運營平臺(本地環境)',
    dev: '商業運營平臺(開發環境)',
    demo: '商業運營平臺',
    test: '商業運營平臺(測試環境)',
    stage: '商業運營平臺(集成環境)'
  },
  "basic": {
    "code-001": "closeAll",//关闭所有
    "code-002": "closeOther",//关闭所有
    "code-003": "switchTab",
    "code-004": "Test select",
    "code-005": "Please enter keywords",
    "code-006": "Dtyunxi Copyright",

    "code-007": "Set up successfully",
    "code-008": "Send verification code successfully",
    "code-009": "Unknown SMS verification code error",
    "code-0010": "Mobile number cannot be empty",
    "code-0011": "Mobile number format error",
    "code-0012": "Get verification code",
    "code-0013": "verification code",
    "code-0014": "Please enter your verification code",
    "code-0015": "submit",
    "code-0016": "reset",
    "code-0017": "mobile number",
    "code-0018": "Please enter your mobile number",

    "code-0019": "Unknown reset password exception",
    "code-0020": "To change the password, you need to log in first",
    "code-0021": "Write off successfully",
    "code-0022": "Change Password",
    "code-0023": "Cancellation",
    "code-0024": "reset password",
    "code-0025": "new password",
    "code-0026": "Please enter your new password",
    "code-0027": "Password must be composed of 6-18 digits, letters or underscores",
    "code-0028": "Confirm password",
    "code-0029": "Reenter password",
    "code-0030": "The two inputs are inconsistent",

    "code-0031": "Unknown login exception",
    "code-0032": "Load user information...",
    "code-0033": "ARM FRAME",
    "code-0034": "Please fill in the user name",
    "code-0035": "Please fill in the password",
    "code-0036": "Please fill in the verification code",
    "code-0037": "Sign in",
    "code-0038": "Dtyunxi",

    "code-0039": "Page not found",
    
    "code-0040": "Admin"
  },
  header : {
    newMessage: '新消息',
    onlineSupport: '在線服務',
    hotlineSupport: '熱線服務',
    application: '应用'
  },
  login: {
    account: {
      placeholeder: '請輸入用戶名',
      nulltips: '請輸入用戶名'
    },
    pwd: {
      placeholeder: '請輸入密碼',
      nulltips: '請輸入密碼'
    },
    vertifiCode: {
      placeholeder: '請輸入驗證碼',
      error: '圖形驗證碼無效'
    },
    btn: {
      text: '登錄'
    },
    copy: {
      name: '雲徙科技有限公司'
    }
  },
  productList: {
    'code-0001': '用戶名',
    'code-0002': '用戶身份',
    'code-0003': '待辦事項',
    'code-0004': '今日新增事項',
    'code-0005': '待辦事項日統計',
    'code-0006': '各應用菜單資源訪問次數和時長統計（圖表） - 按月累計',
    'code-0007': '訪問人數累計和占比',
    'code-0008': '應用管理員'
  },
  tenantDetail: {
    'code-0001': '租户信息',
    'code-0002': '租户编号',
    'code-0003': '租户名称',
    'code-0004': '租户管理员账号',
    'code-0005': '租户管理员联系方式',
    'code-0006': '已授权应用',
    'code-0007': '应用编号',
    'code-0008': '应用名称',
    'code-0009': '应用模板',
    'code-0010': '访问入口',
    'code-0011': '状态',
    'code-0012': '查看',
    'code-0013': '禁用',
    'code-0014': '查询条件',
    'code-0015': '用户名',
    'code-0016': '创建时间',
    'code-0017': '租户管理员列表',
    'code-0018': '新增管理员',
    'code-0019': '姓名',
    'code-0020': '手机号码',
    'code-0021': '邮箱',
    'code-0022': '编辑',
    'code-0023': '禁用',
    'code-0024': '修改密码',
    'code-0025': '删除',
    'code-0026': '启用',
    'code-0027': '新增租户管理员',
    'code-0028': '编辑租户管理员',
    'code-0029': '确定',
    'code-0030': '取消',
    'code-0031': '新密码',
    'code-0032': '确认新密码',
    'code-0033': '密码',
    'code-0034': '请输入租户管理员用户名',
    'code-0035': '请输入登录密码',
    'code-0036': '请输入租户管理员姓名',
    'code-0037': '请输入手机号码',
    'code-0038': '请输入邮箱',
    'code-0039': '请输入租户管理员用户名！',
    'code-0040': '密码不能为空',
    'code-0041': '姓名不能为空',
    'code-0042': '用户名只能输入数字，字母、中划线或下划线，限20字符以内',
    'code-0043': '密码为数字、字母、特殊符号两种及以上组合',
    'code-0044': '姓名长度不能大于20个字符',
    'code-0045': '手机号码有误',
    'code-0046': '请输入正确的邮箱格式',
    'code-0047': '新密码不能为空',
    'code-0048': '确认新密码不能为空',
    'code-0049': '密码为数字、字母、特殊符号两种及以上组合',
    'code-0050': '请输入新密码'
  }
};

export default { ...tc, ...tcList };



// WEBPACK FOOTER //
// ./src/config/langs/tc/index.js